/*
 * Base Google Map example
 */
import React, { Component } from 'react';
import { Button } from 'antd';

import GoogleMapReact from 'google-map-react';
import './CenterMarkerMap.css'

class CenterMarkerMap extends Component {

    constructor(props) {
        super(props);
        this.state = {
            center: { lat: 13.122033, lng: 101.016870 },
            markerPos: { lat: 13.122033, lng: 101.016870 }
        }
        this._onBoundsChange = this._onBoundsChange.bind(this)
        this.getCurrentPosition = this.getCurrentPosition.bind(this)
        this.setPosition = this.setPosition.bind(this)
    }

    setPosition(position){
        const { setLatLng } = this.props
        setLatLng(position)
    }

    async getCurrentPosition(){
        await navigator.geolocation.getCurrentPosition(
            position=>this.setPosition({ lat: position.coords.latitude, lng: position.coords.longitude }))
    }

    _onBoundsChange(center, zoom){
        this.setPosition(center)
    }
    componentDidMount(){
        const { findCurrentOnInit } = this.props
        if (findCurrentOnInit){
            this.getCurrentPosition()
        }
    }
    render() {
        const { draggable, defaultZoom, center } = this.props
        return (
            <div style={{ aspectRatio: 1, width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right', marginBottom: 10 }}>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => this.getCurrentPosition()}
                    >ตำแหน่งปัจจุบัน</Button>
                </div>
                <div id="map-cont" style={{ height: '100%', width: '100%' }}>
                    <GoogleMapReact
                        apiKey={"AIzaSyAdbJX-7pT5ANftYb4rpQc3Md3xIclasos"} // set if you need stats etc ...
                        center={center}
                        defaultZoom={defaultZoom}
                        onBoundsChange={this._onBoundsChange}
                        draggable={draggable}
                    >
                        {/* <Marker lat={markerPos.lat} lng={markerPos.lng} draggable={false} /> */}
                    </GoogleMapReact>

                </div>
            </div>
        );
    }
}

// const Marker = props => {
//     return <div className="SuperAwesomePin" style={{ width: '40px', height: '40px', backgroundColor: 'red' }}></div>
// }

export default CenterMarkerMap;